"use client"

import dynamic from "next/dynamic"
import { useInView } from "react-intersection-observer"
import { ImageCarouselSkeleton } from "./img-carousel"
import Link from "next/link"

const DynamicImgCarousel = dynamic(
  () => import("./img-carousel").then((mod) => mod.ImageCarousel),
  {
    loading: () => <ImageCarouselSkeleton />,
  }
)

export default function ImageCarouselWrapper() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  })

  return (
    <>
      <div className="hidden sm:block" ref={ref}>
        {inView && <DynamicImgCarousel />}
      </div>
      <Link className="sm:hidden pt-20" prefetch={false} href={"/all-products"}>
        <img
          src="/media/slider/banner4.webp"
          alt={`banner-sidebar`}
          className="object-contain w-full h-full rounded-2xl"
          loading="lazy"
          fetchPriority="low"
        />
      </Link>
    </>
  )
}
